const createSlug = (...values) => (
  values
    .join('-')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_]+/g, '-')
    .replace(/(?:(-)[-_]*)|(?:(_)[-_]*)/g, '$1$2')
    .replace(/(?:^[-_]+)|(?:[-_]+$)/g, '')
);

export default createSlug;
